import { render, staticRenderFns } from "./PublicFeed.vue?vue&type=template&id=5bcff1f6&"
import script from "./PublicFeed.vue?vue&type=script&lang=ts&"
export * from "./PublicFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports